import type { LoadTimeEvent } from "common-types";
import { pushTrack } from "utils";

export function sendLoadTimeTrack(
  track: LoadTimeEvent,
  slotIdName: string,
): void {
  pushTrack(track, {
    time: performance.now(),
    slotName: slotIdName,
  });
}
